var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandleToggleUserActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 15,
    viewBox: "0 0 26 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3182 0.777832H7.68182C3.43909 0.777832 0 3.91168 0 7.77783C0 11.644 3.43909 14.7778 7.68182 14.7778H18.3182C22.5609 14.7778 26 11.644 26 7.77783C26 3.91168 22.5609 0.777832 18.3182 0.777832Z",
    fill: "#0A63E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3182 13.7009C21.908 13.7009 24.8182 11.0491 24.8182 7.77783C24.8182 4.50661 21.908 1.85476 18.3182 1.85476C14.7283 1.85476 11.8182 4.50661 11.8182 7.77783C11.8182 11.0491 14.7283 13.7009 18.3182 13.7009Z",
    fill: "#E8F5E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandleToggleUserActiveIcon);
export default __webpack_public_path__ + "static/media/handleToggleUserActiveIcon.c38987778cf0b16e58bfa4c674ffbb14.svg";
export { ForwardRef as ReactComponent };